<div class="icon-link-wrapper">
  <jf-link
    *ngFor="let navigationLink of navigationLinks"
    variant="navigation"
    [routerLink]="[navigationLink.route]"
    [text]="navigationLink.label"
    [iconName]="navigationLink.iconName"
    iconPosition="before"
    [strokeWidth]="1"
    routerLinkActive="active"
    i18n-text
    (click)="trackMatomoEvent('Obere Navigation', 'Klick auf ' + navigationLink.label)"
  ></jf-link>

  <div class="action-button-wrapper">
    <jf-button
      *ngIf="buttonAction && buttonLabel"
      [variant]="buttonVariant"
      [icon]="buttonIcon"
      [text]="buttonLabel"
      iconPosition="left"
      (click)="doButtonAction(); trackMatomoEvent('Button oben rechts', 'Klick auf ' + buttonLabel)"
      [disabled]="!buttonEnabled"
    ></jf-button>

    <div class="buttons-separator" *ngIf="areWeOnNewsArticlePage"></div>

    <jf-button
      *ngIf="areWeOnNewsArticlePage"
      [variant]="'ghost'"
      [icon]="'edit'"
      [text]="'Bearbeiten'"
      iconPosition="left"
      (click)="onEditClick()"
    ></jf-button>

  </div>
</div>

<div class="content-wrapper" [class]="currentRouteClass">
  <div class="router-outlet-content">
    <router-outlet></router-outlet>
  </div>
</div>
